import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';

import style from './ButtonGroup.module.css';

export const ButtonGroup: FCC<{ direction?: 'column'; className?: string }> = ({
  children,
  direction,
  className = '',
}) => <div className={`${style.group} ${direction ? style[direction] : ''} ${className}`}>{children}</div>;
